import * as React from "react";
import { Tooltip } from "@/components/ui";
import { DesignPackageDetail } from "@/services/bedrock/dtos/DesignPackage";
import { isSelfActor, Viewer } from "../viewer";

interface DisabledReasonProps {
  /** When set, the child is wrapped so the tooltip still fires on a disabled button. */
  reason: string | null | undefined;
  children: React.ReactElement;
  "data-testid"?: string;
}

/**
 * Base UI tooltips don't fire on disabled buttons, so a focusable span carries the trigger. The child
 * fills the span, so a button that stretches across its card still does once it's wrapped.
 */
export const DisabledReason: React.FC<DisabledReasonProps> = ({ reason, children, "data-testid": testId }) => {
  if (!reason) return children;
  return (
    <Tooltip>
      <Tooltip.Trigger render={<span tabIndex={0} className="inline-flex [&>*]:flex-1" data-testid={testId} />}>
        {children}
      </Tooltip.Trigger>
      <Tooltip.Content>{reason}</Tooltip.Content>
    </Tooltip>
  );
};

export const READ_ONLY_REASON = "You can view this design but not change it.";

/** Who the viewer is waiting on, or null when nothing is running. */
export function inFlightReasonFor(
  inFlight: DesignPackageDetail["inFlight"] | undefined,
  viewer: Viewer
): string | null {
  if (!inFlight) return null;
  return isSelfActor(inFlight.actor, viewer)
    ? "Wait for your change to finish."
    : `Wait for ${inFlight.actor?.name}'s change to finish.`;
}
